import { Link } from "react-router-dom";
import { Brand } from "./SiteHeader";
import { WA_URL, WhatsAppIcon } from "./WhatsAppButton";

export const SiteFooter = ({ s }) => (
  <footer className="bg-navy text-slate-400 text-sm" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <Brand light />
        <p className="mt-4 text-xs leading-relaxed">{s?.studio_nome}<br />P.IVA {s?.piva}<br />{s?.indirizzo}<br />Professionista incaricato: {s?.avvocato} · {s?.ordine}{s?.iscrizione ? ` · ${s.iscrizione}` : ""}</p>
      </div>
      <div className="flex flex-col gap-2">
        <p className="text-xs uppercase tracking-widest text-gold mb-1">Informazioni</p>
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy policy</Link>
        <Link to="/cookie" data-testid="footer-cookie-link" className="hover:text-white">Cookie policy</Link>
        <a href="#faq" className="hover:text-white">Domande frequenti</a>
      </div>
      <div className="flex flex-col gap-2">
        <p className="text-xs uppercase tracking-widest text-gold mb-1">Contatti</p>
        <span>PEC: <a href={`mailto:${s?.pec}`} className="hover:text-white">{s?.pec}</a></span>
        {s?.telefono && <span>Tel: {s.telefono}</span>}
        <a href={WA_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="inline-flex items-center gap-2 hover:text-white"><WhatsAppIcon className="h-4 w-4 text-[#25D366]" />WhatsApp 392 3598141</a>
        <Link to="/studio/login" data-testid="footer-staff-login-link" className="hover:text-white mt-2 text-xs">Area riservata studio</Link>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs px-5">© {new Date().getFullYear()} {s?.studio_nome} · P.IVA {s?.piva}. Servizio professionale non affiliato a Consap S.p.A.</div>
  </footer>
);
